<template>
  <div class="vx-col w-full mb-base">
    <corporate-lom-side-view
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
      @onCorporateLomUploading="corporateLomUploading"
      @onCorporateUploadCompleted="corporateUploadCompleted"
      @onCorporateUploadFailed="corporateUploadFailed"
      @onCorporateLomUpdated="corporateLomUpdated"
      @onCorporateLomInserted="corporateLomInserted"
    />
    <vx-card ref="listCard" :title="$t('CashFlow.CorporateLom.Title')" title-color="black" refresh-content-action @refresh="refreshCorporateLomList"> 
      <vs-row vs-type="flex" vs-justify="space-between">
            <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="12">
              <vs-button class="mr-3 mb-5" type="border" icon-pack="feather" icon="icon-plus" color="primary" @click="addNewData">{{$t('AddNew')}}</vs-button>
              <vs-button class="mr-3 mb-5" type="border" icon-pack="feather" icon="icon-upload" color="primary" target :href="{url: 'https://agnicoeagle.sharepoint.com/sites/AEM_Global_CashFlow/_layouts/15/Doc.aspx?OR=teams&action=edit&sourcedoc={A800E767-9A1A-4BA8-8C9B-593B64BCA227}'}">{{$t('CashFlow.Lom.UploadTemplateFile')}}</vs-button>
            </vs-col>
      </vs-row>

      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        :context="context"
        class="ag-theme-material w-200 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="corporateLoms"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="false"
        :suppressPaginationPanel="true"
        :enableCellChangeFlash="false"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>

    </vx-card>
    <vs-popup class="holamundo" :title="$t('CashFlow.Lom.UploadInProgress')" :active.sync="uploadPopupActive" button-close-hidden="false">
      <vs-progress indeterminate color="primary">primary</vs-progress>
    </vs-popup>
  </div>
</template>

<script>

import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";

import Vue from "vue";
import moduleCashflow from "@/store/cashflow/moduleCashFlow.js";
import corporateLomSideView from "./components/corporateLomSideView";

import corporateLomActionsCellRenderer from './../components/lomActionsCellRenderer.vue'
import { odtHostname } from '@/environment/environment'

export default {
  components: {
    AgGridVue,
    corporateLomSideView
  },
  data() {
    return {
      selected: [],
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},
      uploadPopupActive: false,
      defaultColDef: {
        sortable: true,
        resizable: true,
        editable: false
      },
      gridApi: null,
      gridOptions: {
        getRowNodeId: (data) => {
          return data.id;
        }
      },
      context: { componentParent: this },
      columnDefs: [
        {
          headerName: 'Actions',
          field: 'id',
          width: 170,
          editable: false,
          sortable: false,
          cellRendererFramework: Vue.extend(corporateLomActionsCellRenderer)
        },
        {
          headerName: this.$t('CashFlow.Lom.Name'),
          field: "name",
          width: 150,
          filter:'agTextColumnFilter'
        },
        {
          headerName: this.$t('CashFlow.Lom.Version'),
          field: "version",
          width: 125,
          filter:'agNumberColumnFilter'
        },
        {
          headerName: this.$t('CashFlow.Currency.Name'),
          field: "currency",
          width: 150,
          filter:'agTextColumnFilter',
          valueGetter: (params) => {
            return this.$t('CashFlow.Currency.' + params.data.currency);
          }
        },
        {
          headerName: this.$t('CashFlow.Lom.Availability'),
          field: "isPublic",
          width: 150,
          filter:'agTextColumnFilter',
          valueGetter: (params) => {
            if (params.data.isPublic) {
              return this.$t('CashFlow.Lom.AvailabilityPublic');
            }
            else {
              return this.$t('CashFlow.Lom.AvailabilityPrivate');
            }  
          }
        }
      ],
      components: {
        corporateLomActionsCellRenderer
      }
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    corporateLoms() {
      return this.$store.state.cashflow.corporateLoms;
    }
  },
  methods: {
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    editData(data) {
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    openDeleteConfirm(id, code) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: code,
        text: this.$t('CashFlow.Lom.ConfirmDelete', { code }),
        accept: this.deleteData,
        parameters: id
      });
    },
    deleteData(id) {
      this.$store.dispatch("cashflow/removeCorporateLom", id)
        .then(() => {
          this.$vs.notify({
            color: "success",
            title: this.$t("Success"),
            text: this.$t("CashFlow.Lom.LomDeleted")
          });
        });
    },
    downloadModel(data) {
      this.$webApi.get(`/cashflow/projectLom/download/${data.id}`, { responseType: 'blob' })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${data.name}.xlsx`);
          document.body.appendChild(link);
          link.click();
        });
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    corporateLomUpdated(corporateLom) {
      this.$vs.notify({
        title: this.$t("Success"),
        text: this.$t("SaveSuccess"),
        color: "success",
        iconPack: 'feather',
        icon:'icon-check'
      });
      this.toggleDataSidebar(false);
      const rowNode = this.gridApi.getRowNode(corporateLom.id);
      if (rowNode) {
        rowNode.setData(corporateLom);
      }

      this.gridApi.applyTransaction({ update: [corporateLom] });
    },
    corporateLomInserted(corporateLom) {
      this.$vs.notify({
        title: this.$t("Success"),
        text: this.$t("InsertSuccess"),
        color: "success",
        iconPack: 'feather',
        icon:'icon-check'
      });
      this.toggleDataSidebar(false);
      this.gridApi.applyTransaction({ update: [corporateLom] });
    },
    corporateLomUploading() {
      this.toggleDataSidebar(false);
      this.uploadPopupActive = true;
    },
    corporateUploadCompleted(corporateLom) {
      this.$vs.notify({
        title: this.$t("Success"),
        text: this.$t("CashFlow.Lom.UploadCompleted"),
        color: "success",
        iconPack: 'feather',
        icon:'icon-check'
      });
      this.uploadPopupActive = false;
      const rowNode = this.gridApi.getRowNode(corporateLom.id);
      if (rowNode) {
        rowNode.setData(corporateLom);
      }

      this.gridApi.applyTransaction({ update: [corporateLom] });
    },
    corporateUploadFailed() {
      this.uploadPopupActive = false;
      this.$vs.notify({
        title: this.$t("UploadFailedTitle"),
        text: this.$t("UploadFailed"),
        color: "danger",
        iconPack: 'feather',
        icon:'icon-x'
      });
    },
    refreshCorporateLomList() {
      this.$store.dispatch("cashflow/fetchCorporateLomListItems").then(() => {
        this.$refs.listCard.removeRefreshAnimation();
      });
    },
    viewData(dsa) {
      this.$http.get(`/api/cashflow/corporateLom/download/${dsa.id}`, { responseType: 'blob' })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', this.params.data.name + '.xlsx');
          document.body.appendChild(link);
          link.click();
        });
    }
  },
  created() {
    if (!moduleCashflow.isRegistered) {
      this.$store.registerModule("cashflow", moduleCashflow);
      moduleCashflow.isRegistered = true;
    }
  },
  mounted() {
    window.location.href = odtHostname + "/bsg/";
    if (!this.isMounted) {
      this.$refs.listCard.refreshcard();
    }
    this.isMounted = true;
    this.gridApi = this.gridOptions.api;
  }
};
</script>

<style lang="scss">
#data-list-list-view {
.vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 0.8rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 8px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
        width: 50px;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--tbody-table {
      min-width: 200px;
    }

    .vs-table--pagination {
      justify-content: center;
    }

     .con-expand-muckTypes {
     width: 100%;
      .con-btns-muckType {
        display:flex;
        padding:10px;
        padding-bottom:0px;
        justify-content:flex-start;
        align-items:left;
        justify-content:space-between;
        .con-muckTypex {
          .con-muckType-comments {
            padding-left:5px;
          }
        }
      }
    }
  }
}
</style>